import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';

function PotatoMoonMark({ size = 44 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 80 80" data-testid="potato-moon-logo" aria-label="Potato Moon" xmlns="http://www.w3.org/2000/svg">
      <circle cx="40" cy="40" r="34" fill="#E0AAFF" stroke="#3C096C" strokeWidth="3.5"/>
      <ellipse cx="56" cy="15" rx="5" ry="4" transform="rotate(-15 56 15)" fill="#D9B98A" stroke="#3C096C" strokeWidth="1.3"/>
      <circle cx="54.5" cy="14.5" r="0.8" fill="#3C096C"/>
      <circle cx="57.5" cy="16" r="0.8" fill="#3C096C"/>
      <path d="M6.5 46 L20 30 L27 37 L40 20 L48 30 L58 22 L73.5 43 A34 34 0 0 1 6.5 46 Z" fill="#9D4EDD"/>
      <path d="M6.5 46 L20 30 L27 37 L40 20 L48 30 L58 22 L73.5 43" fill="none" stroke="#3C096C" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
      <circle cx="30" cy="56" r="1.6" fill="#5A189A"/>
      <circle cx="44" cy="52" r="1.6" fill="#5A189A"/>
      <circle cx="55" cy="58" r="1.6" fill="#5A189A"/>
    </svg>
  );
}

export default function Nav() {
  const loc = useLocation();
  const links = [
    { to: '/#field-notes', label: 'Field notes' },
    { to: '/#about', label: 'About' },
    { to: '/#work', label: 'Work' },
    { to: '/#ops', label: 'Ops' },
  ];
  return (
    <motion.header
      initial={{ y: -30, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
      className="fixed top-0 left-0 right-0 z-50 backdrop-blur-md bg-paper/60 border-b border-ink/5"
      data-testid="site-nav"
    >
      <div className="mx-auto max-w-[1440px] px-6 md:px-12 py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3 group" data-testid="nav-home-link" aria-label="Eileen Tadeo — home">
          <PotatoMoonMark size={44} />
        </Link>
        <nav className="flex items-center gap-2 md:gap-6 mono text-[11px] md:text-xs uppercase tracking-[0.22em]">
          {links.map((l) => (
            <a
              key={l.to}
              href={l.to}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, '-')}`}
              className="relative py-2 px-1 text-ink/70 hover:text-ink transition-colors"
            >
              <span>{l.label}</span>
              <span className="absolute left-0 -bottom-0.5 h-px w-0 bg-orchid transition-all duration-300 group-hover:w-full hover:w-full" />
            </a>
          ))}
          {loc.pathname !== '/admin' && (
            <Link to="/admin/login" data-testid="nav-admin-link" className="text-ink/40 hover:text-ink transition-colors">·</Link>
          )}
        </nav>
      </div>
    </motion.header>
  );
}
